var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconLocation16Px = function SvgIconLocation16Px(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    clipPath: "url(#iconLocation16px_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.375 16c-.12-.116-.263-.217-.358-.352-.944-1.346-1.895-2.688-2.813-4.052-.76-1.128-1.423-2.313-1.879-3.602-.285-.805-.463-1.63-.45-2.49.04-2.416 1.694-4.59 4.018-5.27a5.624 5.624 0 0 1 7.055 3.99c.31 1.182.19 2.342-.178 3.489-.403 1.252-1.01 2.408-1.73 3.5-.839 1.267-1.72 2.505-2.583 3.756-.157.227-.304.462-.473.679-.102.13-.238.235-.359.352zm.121-1.31c.028-.031.042-.045.054-.062.863-1.244 1.743-2.478 2.584-3.737.712-1.067 1.325-2.19 1.728-3.416.306-.93.44-1.876.22-2.845-.676-2.957-3.789-4.503-6.554-3.259-1.866.84-2.981 2.922-2.665 4.95.136.868.432 1.68.808 2.466.622 1.3 1.42 2.495 2.245 3.672.52.741 1.046 1.478 1.58 2.231"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.514 2.81a2.817 2.817 0 0 1 2.799 2.827 2.82 2.82 0 0 1-2.827 2.8A2.82 2.82 0 0 1 5.687 5.61a2.82 2.82 0 0 1 2.827-2.8m-.014.938a1.88 1.88 0 0 0-1.875 1.879A1.883 1.883 0 0 0 8.49 7.499a1.88 1.88 0 0 0 1.883-1.871A1.88 1.88 0 0 0 8.5 3.748"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "iconLocation16px_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.504 0h15.993v16H.504z"
  })))));
};
export default SvgIconLocation16Px;